//
// repeaterのラッパーメソッド
// - options: maxItems - 最大アイテム数制限
// - onShow: 表示前処理コールバック
//
window.initializeRepeater = function(selector, options) {
    options = options || {};
    options.isFirstItemUndeletable = true,
    options.show = function () {
        const onShow = options.onShow || null;
        if (onShow) {
            onShow(this);
        }
        $(this).show();

        //
        // 最大アイテム数制限
        //
        const maxItems = options.maxItems || 0;
        if (maxItems > 0) {
            const $repeater = $(selector);
            var currentItemCount = $repeater.find('[data-repeater-item]').length;
            if (currentItemCount >= maxItems) {
                // 追加ボタンを無効化
                $repeater.find('[data-repeater-create]').hide();
            }
            else {
                $repeater.find('[data-repeater-create]').show();
            }
        }
    };
    options.hide = function() {
        const onHide = options.onHide || null;
        if (onHide) {
            onHide(this);
        }
        $(this).remove();
        const onRemoved = options.onRemoved || null;
        if (onRemoved) {
            onRemoved();
        }

        //
        // 最大アイテム数制限
        //
        const maxItems = options.maxItems || 0;
        if (maxItems > 0) {
            const $repeater = $(selector);
            var currentItemCount = $repeater.find('[data-repeater-item]').length;
            if (currentItemCount >= maxItems) {
                // 追加ボタンを無効化
                $repeater.find('[data-repeater-create]').hide();
            }
            else {
                $repeater.find('[data-repeater-create]').show();
            }
        }
    };
    $(selector).repeater(options);

    // $(selector).repeater({
    //     isFirstItemUndeletable: true,
    //     show: function () {
    //
    //         const onShow = options.onShow || null;
    //         if (onShow) {
    //             onShow(this);
    //         }
    //         $(this).show();
    //
    //         //
    //         // 最大アイテム数制限
    //         //
    //         const maxItems = options.maxItems || 0;
    //         if (maxItems > 0) {
    //             const $repeater = $(selector);
    //             var currentItemCount = $repeater.find('[data-repeater-item]').length;
    //             if (currentItemCount >= maxItems) {
    //                 // 追加ボタンを無効化
    //                 $repeater.find('[data-repeater-create]').hide();
    //             }
    //             else {
    //                 $repeater.find('[data-repeater-create]').show();
    //             }
    //         }
    //     },
    //     hide: function() {
    //         const onHide = options.onHide || null;
    //         if (onHide) {
    //             onHide(this);
    //         }
    //         $(this).remove();
    //         const onRemoved = options.onRemoved || null;
    //         if (onRemoved) {
    //             onRemoved();
    //         }
    //
    //         //
    //         // 最大アイテム数制限
    //         //
    //         const maxItems = options.maxItems || 0;
    //         if (maxItems > 0) {
    //             const $repeater = $(selector);
    //             var currentItemCount = $repeater.find('[data-repeater-item]').length;
    //             if (currentItemCount >= maxItems) {
    //                 // 追加ボタンを無効化
    //                 $repeater.find('[data-repeater-create]').hide();
    //             }
    //             else {
    //                 $repeater.find('[data-repeater-create]').show();
    //             }
    //         }
    //     },
    // });
};
